import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/Guest-blank.webp";
import ThumbImg from "../../assets/images/conversations/blank.png";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: pc-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .pc-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }

  .pc-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 - HERO
  ══════════════════════════════════════ */
  .pc-hero {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .pc-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .pc-hero__left {
    display: flex;
    flex-direction: column;
    gap: 44px;
  }
  .pc-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .pc-hero__title.pc-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .pc-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .pc-hero__spotify.pc-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .pc-hero__spotify iframe {
    display: block;
    width: 100%;
    height: 152px;
    border: none;
    border-radius: 12px;
  }
  .pc-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .pc-hero__right.pc-visible {
    opacity: 1;
    transform: translateY(0);
  }

  /* thumbnail */
  .pc-yt-thumb {
    position: relative;
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    display: block;
    background: #000;
  }
  .pc-yt-thumb img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 12px;
    transition: opacity 0.3s ease;
  }
  .pc-yt-thumb:hover img { opacity: 0.85; }
  .pc-yt-thumb__play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: none;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }
  .pc-yt-thumb__play img {
    width: 40px;
    height: 44px;
  }
  .pc-yt-iframe-wrap {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    border-radius: 12px;
    overflow: hidden;
  }
  .pc-yt-iframe-wrap iframe {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 - BODY
  ══════════════════════════════════════ */
  .pc-body {
    padding-bottom: 100px;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .pc-body.pc-visible { opacity: 1; transform: translateY(0); }
  .pc-body__para {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #E2E2E2;
    line-height: 160%;
    margin-bottom: 14px;
  }
  .pc-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 - OUR GUEST (1 guest)
  ══════════════════════════════════════ */
  .pc-guest {
    padding-bottom: 100px;
    text-align: center;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .pc-guest.pc-visible { opacity: 1; transform: translateY(0); }
  .pc-guest__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 60px;
  }
  .pc-guest__photo-bg {
    display: inline-block;
    width: 445px;
    height: 500px;
    background: #743FAC;
    border-radius: 12px;
    overflow: hidden;
  }
  .pc-guest__photo-bg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    display: block;
  }
  .pc-guest__name {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .pc-inner { padding-left: 32px; padding-right: 32px; }
    .pc-hero { padding-top: 32px; padding-bottom: 48px; }
    .pc-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .pc-hero__title { font-size: 24px; }
    .pc-hero__left { gap: 16px; }
    .pc-guest__title { font-size: 24px; margin-bottom: 24px; }
    .pc-guest__photo-bg { width: 260px; height: 300px; }
    .pc-guest__name { font-size: 24px; margin-top: 18px; }
    .pc-body__para { font-size: 14px; margin-bottom: 12px; }
    .pc-body { padding-bottom: 48px; }
    .pc-guest { padding-bottom: 48px; }
    .pc-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .pc-inner { padding-left: 16px; padding-right: 16px; }
    .pc-hero { padding-top: 51px; padding-bottom: 30px; }
    .pc-hero__grid { grid-template-columns: 1fr; gap: 40px; }
    .pc-hero__left { gap: 30px; }
    .pc-hero__title { font-size: 30px; }
    .pc-body__para { font-size: 16px; margin-bottom: 10px; }
    .pc-guest__title { font-size: 30px; margin-bottom: 20px; text-align:left; }
    .pc-guest__photo-bg { width: 100%; height: 386px; }
    .pc-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .pc-body { padding-bottom: 30px; }
    .pc-guest { padding-bottom: 30px; }
    .pc-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

/* ─────────────────────────────────────────────
   FADE-UP HOOK
───────────────────────────────────────────── */
function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("pc-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

/* ─────────────────────────────────────────────
   YOUTUBE EMBED
───────────────────────────────────────────── */
const YT_VIDEO_ID = "YOUTUBE_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);

  if (playing) {
    return (
      <div className="pc-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 67 Pramit Pal Chaudhuri"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="pc-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 67 Pramit Pal Chaudhuri thumbnail" />
      <div className="pc-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   SECTIONS
───────────────────────────────────────────── */
function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);

  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="pc-hero">
      <div className="pc-inner">
        <div className="pc-hero__grid">
          <div className="pc-hero__left">
            <h1 ref={titleRef} className="pc-hero__title">
              EP 67 | Geopolitics has returned to the centre of the energy conversation. | Pramit Pal CHAUDHURI
            </h1>
            <div ref={spotifyRef} className="pc-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/6OtSAtHbLFYJ4Ch6X9peXJ?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 67 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="pc-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="pc-body">
      <div className="pc-inner">
        <p className="pc-body__para">
          Over the past decade, the energy transition has largely been framed as a technology and capital story, batteries getting cheaper, EV adoption accelerating, hydrogen scaling, and climate capital flowing across borders.
        </p>
        <p className="pc-body__para">
          But in the last few months, something fundamental has shifted. Geopolitics is back at the center of energy.
        </p>
        <p className="pc-body__para">
          The escalating conflict involving Iran, the return of a more protectionist and unpredictable United States under President Trump, and the increasingly assertive roles of China and Russia are no longer distant headlines. They are now shaping supply chains, energy prices, and strategic decisions in boardrooms across the world.
        </p>
        <p className="pc-body__para">
          For CEOs in the energy transition space, this raises urgent questions:<br />
          Are we entering a new era of energy fragmentation?<br />
          Will supply chains be redrawn along political lines?<br />
          And most importantly, how should businesses prepare for a world where geopolitics, not just economics, drives outcomes?
        </p>
        <p className="pc-body__para">
          To help us unpack this, I'm delighted to welcome Pramit Pal Chaudhary.<br />
          Pramit is one of India's most respected voices on geopolitics and global strategy. He has been a foreign policy advisor to the Indian government, a senior fellow at leading global think tanks, and a long-time analyst of how power, policy, and economics intersect.
        </p>
        <p className="pc-body__para">
          Today, we go beyond headlines to explore the tectonic shifts shaping the future of energy, and what they mean for India and the world.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="pc-guest">
      <div className="pc-inner">
        <h2 className="pc-guest__title">Our Guest</h2>
        <div>
          <div className="pc-guest__photo-bg">
            <img src={GuestImg} alt="Pramit Pal Chaudhuri" />
          </div>
          <p className="pc-guest__name">Pramit Pal CHAUDHURI</p>
        </div>
      </div>
    </section>
  );
}

/* ─────────────────────────────────────────────
   ROOT
───────────────────────────────────────────── */
export default function Ep67PramitPalChaudhuri() {
  return (
    <>
      <style>{CSS}</style>
      <div className="pc-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}